export default __webpack_public_path__ + "static/media/hekma.524c56f2.png";